import './index.scss'

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let contentH = $(document).height(); //内容高度

  let fixedTop = $('.section1 .cont').offset().top - 40
  let fixedBtm = $('.section1 .cont').offset().top + $('.section1 .cont').outerHeight() - $('.section1 .fixed-cont').outerHeight() - 40

  if($(window).width() >= 992){
    if (scroH <= fixedTop) {
      $('.section1 .fixed-cont').removeClass('fixed')
    }else if (scroH > fixedTop && scroH < fixedBtm) {
      $('.section1 .fixed-cont').addClass('fixed').removeClass('abs')
    }else{
      $('.section1 .fixed-cont').addClass('abs').removeClass('fixed')
    }
  }
  
});